<template>
  <div>
    <Toasts :text="message" color="success" />
    <Toasts :text="error" color="danger" />
  </div>
</template>

<script>
import Toasts from './Toasts.vue';

export default {
  components: {
    Toasts,
  },
  name: 'BasicToasts',
  data() {
    return {
      error: '',
      message: '',
    };
  },
  created() {
    this.$root.$on('toast:notify', (msg) => {
      this.message = '';
      this.$nextTick(() => {
        this.message = msg;
      });
    });
    this.$root.$on('toast:error', (msg) => {
      this.error = '';
      this.$nextTick(() => {
        this.error = msg;
      });
    });
    this.$root.$on('toast:notification', (notification) => {
      // const { title, body, icon } = notification;
      const { body } = notification;
      this.message = '';
      this.$nextTick(() => {
        this.message = body;
      });
    });
    this.$root.$on('network.error', () => {
      this.error = '';
      this.$nextTick(() => {
        this.error = 'There was an error communicating with the server';
      });
    });
  },
  destroyed() {
    this.$root.$off('toast:notify');
    this.$root.$off('toast:notification');
    this.$root.$off('network.error');
  },
};
</script>
